import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const goToAnchor = (href: string) => {
    setMenuOpen(false);
    const [path, hash] = href.split("#");
    const targetPath = path || "/";
    if (location.pathname === targetPath && hash) {
      const el = document.getElementById(hash);
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    navigate(targetPath);
    if (hash) {
      window.setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[70px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label={`${site.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              {site.name}
            </span>
            <span className="mt-0.5 text-[11px] font-label tracking-[0.18em] text-foreground-500">
              {site.domain}
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => goToAnchor(link.href)}
              className="cursor-pointer whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => goToAnchor("/#rank")}
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
          >
            <i className="ri-search-line"></i>
            搜榜单
          </button>
          <Link
            to="/about"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
          >
            关于我们
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <button
                key={link.href}
                type="button"
                onClick={() => goToAnchor(link.href)}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2.5 text-left text-sm font-label text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}